import { render, staticRenderFns } from "./Distributions.vue?vue&type=template&id=e226d536"
import script from "./Distributions.vue?vue&type=script&lang=js"
export * from "./Distributions.vue?vue&type=script&lang=js"
import style0 from "./Distributions.vue?vue&type=style&index=0&id=e226d536&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports